import {
  actualizarSiteSetting,
  obtenerSiteSettingsMap,
} from "./siteSettingsService";

const KEY = "site.visibility";

export const visibilityGroups = [
  {
    key: "pages",
    label: "Páginas públicas",
    description: "Ocultarlas también las quita del menú y bloquea el acceso directo.",
    items: [
      { key: "pages.calendario", label: "Calendario" },
      { key: "pages.resultados", label: "Resultados" },
      { key: "pages.federacion", label: "La Federación" },
      { key: "pages.noticias", label: "Noticias" },
      { key: "pages.historias", label: "Historias" },
      { key: "pages.alojamiento", label: "Alojamiento" },
      { key: "pages.futuro", label: "Jóvenes Bochófilos" },
      { key: "pages.pasado", label: "Jugadores históricos" },
    ],
  },
  {
    key: "home",
    label: "Secciones del inicio",
    items: [
      { key: "home.resultados", label: "Resultados" },
      { key: "home.proximasFechas", label: "Próximas fechas" },
      { key: "home.novedades", label: "Novedades" },
      { key: "home.comunidad", label: "Comunidad" },
      { key: "home.historias", label: "Historias" },
      { key: "home.enviarHistoria", label: "Enviar historia" },
      { key: "home.futuro", label: "Jóvenes Bochófilos" },
      { key: "home.pasado", label: "Jugadores históricos" },
      { key: "home.alojamiento", label: "Alojamiento" },
    ],
  },
  {
    key: "federacion",
    label: "Secciones de La Federación",
    items: [
      { key: "federacion.historia", label: "Nuestra historia" },
      { key: "federacion.autoridades", label: "Autoridades" },
      { key: "federacion.misionVision", label: "Misión y visión" },
      { key: "federacion.reglamentacion", label: "Reglamentación" },
    ],
  },
  {
    key: "alojamiento",
    label: "Secciones de Alojamiento",
    items: [
      { key: "alojamiento.casa", label: "Casa del Bochófilo" },
      { key: "alojamiento.albergue", label: "Albergue Estudiantil" },
      { key: "alojamiento.contacto", label: "Contacto" },
    ],
  },
];

const DEFAULT_VISIBILITY = visibilityGroups.reduce((result, group) => {
  group.items.forEach((item) => {
    result[item.key] = true;
  });
  return result;
}, {});

let cachedVisibility = null;

export function crearSiteVisibility() {
  return { ...DEFAULT_VISIBILITY };
}

export async function obtenerSiteVisibility({ force = false } = {}) {
  if (cachedVisibility && !force) return { ...cachedVisibility };
  const settings = await obtenerSiteSettingsMap();
  const visibility = crearSiteVisibility();
  if (settings[KEY]) {
    const saved = JSON.parse(settings[KEY]);
    if (saved && typeof saved === "object" && !Array.isArray(saved)) {
      Object.keys(visibility).forEach((key) => {
        if (typeof saved[key] === "boolean") visibility[key] = saved[key];
      });
    }
  }
  cachedVisibility = visibility;
  return { ...visibility };
}

export async function guardarSiteVisibility(visibility) {
  const normalized = crearSiteVisibility();
  Object.keys(normalized).forEach((key) => {
    if (typeof visibility[key] === "boolean") normalized[key] = visibility[key];
  });
  await actualizarSiteSetting(KEY, {
    label: "Visibilidad del sitio",
    group: "visibility",
    value: JSON.stringify(normalized),
  });
  cachedVisibility = normalized;
  return { ...normalized };
}
